import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { clickedSubscribeCTA, navigatedToPage } from '../../../actions/segmentEvents';
import PremiumLandingFeatures from '../../../components/PremiumLandingFeatures';
import PremiumLandingHeader from '../../../components/PremiumLandingHeader';
import PremiumLandingSection from '../../../components/PremiumLandingSection';
import PremiumBenefitsCreative from '../../../components/PremiumBenefitsCreative';
import en from '../../../intl/translations/en';
import forecasterImage from './forecaster.png';
import forecastsImage from './forecasts.png';
import buoysImage from './buoys.png';
import camRewindMP4 from './cam-rewind.mp4';
import premiumCamMP4 from './premium-cam.mp4';
import chartGIF from './charts.gif';
import headerBackground from './header-background.jpg';
import forecastersBackground from './forecasters-background.jpg';
import chartsBackground from './charts-background.png';
import buoysBackground from './buoys-background.jpg';
import benefitsBackground from './benefits-background.jpg';
import CamRewindPoster from './cam-rewind-poster.jpg';
import HdCamsPoster from './ad-free-hd-cams-poster.jpg';

class PremiumLanding extends Component {
  constructor(props) {
    super(props);
    const { doNavigatedToPage } = this.props;
    doNavigatedToPage('Premium Benefits');
  }

  renderPremiumLanding = (copy, doClickedSubscribeCTA) => (
    <div className="premium-landing">
      <Helmet
        title="Premium Benefits - Surfline"
      />
      <PremiumLandingHeader
        backgroundImage={headerBackground}
        copy={copy.header}
        doClickedSubscribeCTA={doClickedSubscribeCTA}
      />
      <PremiumLandingFeatures features={copy.features} />
      <PremiumLandingSection
        section="Ad Free HD Cams"
        anchor="ad-free-hd-cams"
        orientation="center"
        copy={en.PremiumLanding.cams}
        creative={(
          <video
            src={premiumCamMP4}
            poster={HdCamsPoster}
            controls
            autoPlay
            loop
            muted
          />
)}
        doClickedSubscribeCTA={doClickedSubscribeCTA}
      />
      <PremiumLandingSection
        section="Premium-Analysis"
        anchor="forecast-team"
        orientation="left"
        contentPosition="top"
        copy={en.PremiumLanding.forecasters}
        creative={<img src={forecasterImage} alt="Forecaster" />}
        doClickedSubscribeCTA={doClickedSubscribeCTA}
        backgroundImage={forecastersBackground}
      />
      <PremiumLandingSection
        section="Long Range Forecast"
        anchor="long-range-dashboard"
        orientation="left"
        copy={en.PremiumLanding.forecasts}
        creative={<img src={forecastsImage} alt="Forecasts" />}
        doClickedSubscribeCTA={doClickedSubscribeCTA}
      />
      <PremiumLandingSection
        section="Exclusive Forecast Tools"
        anchor="exclusive-forecast-tools"
        orientation="center"
        copy={en.PremiumLanding.tools}
        creative={<img src={chartGIF} alt="Charts" />}
        doClickedSubscribeCTA={doClickedSubscribeCTA}
        backgroundImage={chartsBackground}
      />
      <PremiumLandingSection
        section="Proprietary Buoys"
        anchor="proprietary-buoy-data"
        orientation="left"
        copy={en.PremiumLanding.buoys}
        creative={<img src={buoysImage} alt="Buoys" />}
        doClickedSubscribeCTA={doClickedSubscribeCTA}
        backgroundImage={buoysBackground}
      />
      <PremiumLandingSection
        section="Cam Rewind"
        anchor="cam-rewind"
        orientation="center"
        copy={en.PremiumLanding.rewind}
        creative={(
          <video
            src={camRewindMP4}
            poster={CamRewindPoster}
            controls
            autoPlay
            loop
            muted
          />
)}
        doClickedSubscribeCTA={doClickedSubscribeCTA}
      />
      <PremiumLandingSection
        section="Premium-Benefits"
        anchor="premium-benefits"
        orientation="center"
        copy={en.PremiumLanding.benefits}
        creative={<PremiumBenefitsCreative />}
        doClickedSubscribeCTA={doClickedSubscribeCTA}
        backgroundImage={benefitsBackground}
      />
    </div>
  );

  render() {
    const { doClickedSubscribeCTA } = this.props;
    const copy = en.PremiumLanding;
    return this.renderPremiumLanding(copy, doClickedSubscribeCTA);
  }
}

PremiumLanding.propTypes = {
  doClickedSubscribeCTA: PropTypes.func.isRequired,
  doNavigatedToPage: PropTypes.func.isRequired,
};

export default connect(
  null,
  dispatch => ({
    doClickedSubscribeCTA: properties => dispatch(clickedSubscribeCTA(properties)),
    doNavigatedToPage: (name, properties) =>
      dispatch(navigatedToPage(name, properties)),
  }),
)(PremiumLanding);
